<p>
  intouch-loader works!
</p>

<div class="preloader"></div>
